// extracted by mini-css-extract-plugin
module.exports = {"back-previous":"BackToPrevious_back-previous__7XgsH"};